export default __webpack_public_path__ + "static/media/misc-books5-480w.f1272eed.webp";